module.exports = "<conteudo-consulta titulo=Fretes btn-voltar=vm.btnVoltar container-id=infinite-scroll-container> <listagem-fretes filtro=vm.filtro index=vm.index scroll-container-id=infinite-scroll-container> </listagem-fretes> </conteudo-consulta> ";


/*****************
 ** WEBPACK FOOTER
 ** ./pages/consulta/fretes/listagem.html
 ** module id = 100
 ** module chunks = 0
 **/